import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';
import { BuyService } from '../services/buy.service';
import { finalize } from 'rxjs/operators';
import { SessionService } from '../services/session.service';
import { ContactService } from '../services/contact.service';
import { UserElectricityMeterService } from '../services/user-electricity-meter.service';
import { ContactElectricityMeterService } from '../services/contact-electricity-meter.service';
@Component({
  selector:'app-buy',
  standalone:true,
  imports:[CommonModule, FormsModule],
  template:`
     <div class="spinner-container" *ngIf="isLoadingPageContent">
      <span class="spinner"></span>
    </div>
    <div *ngIf="showPageContent">
      <!-- CONTACT -->
      <div *ngIf="showBeneficiarySection">
        <div class="line-segment"  *ngIf="!selectedContact && !showAddNewContact">
          <div [class.selected]="buyMode==='buy'"
              (click)="changeBuyMode('buy')">
            Buy
          </div>
          <div [class.selected]="buyMode==='payforme'"
              (click)="changeBuyMode('payforme')">
            Pay for me
          </div>
        </div>
        <!-- CONTACTS -->
        <div *ngIf="!selectedContact && !showAddNewContact">
          <div class="title">
            {{selectContactSectionTopHeading}}
          </div>
          <!-- ADD CONTACT BUTTON -->
          <div class="edit-only-top-bar" >
            <div class="top-actions">
              <button class="icon-btn " (click)="onAddNewContact()">
                <span class="icon-text">+</span>
              </button>
            </div>
          </div>
      
          <!-- CONTACT SEARCH INPUT -->
          <div class="search-box">
            <input class="search-input"
                  placeholder="{{contactSearchInputPlaceholder}}"
                  [(ngModel)]="contactSearchInput">
            <span class="search-icon">⌕</span>
          </div>
          <!-- CONTACTS LIST-->
          <div class="buy-scroll">
            <div class="table-list">
              <div class="row"
                  *ngFor="let c of filteredContacts()"
                  (click)="selectContact(c)">
                <div class="contact-details">
                  <strong class="tx-title">
                    {{c.name}}
                  </strong>
                  <small class="tx-number">
                    {{c.displayNumber}}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ADD CONTACT -->
        <div *ngIf="showAddNewContact">
          <div class="back-btn"
              (click)="closeAddNewContact()">
            ←
          </div>
          <div class="section-title">
            {{addNewContactSectionTopHeading}}
          </div>
          <!-- NAME -->
          <div>
            <label class="field-label">Name</label>
            <input class="input"
                  placeholder="Enter name"
                  [(ngModel)]="newContactName"
                  (ngModelChange)="contactNameValidationMessage=''">
              <div class="validation-message"
                *ngIf="contactNameValidationMessage">
              {{contactNameValidationMessage}}
            </div>
            <!-- WHATSAPP NUMBER -->
            <label class="field-label">WhatsApp Number</label>
            <div class="phone-input">
              <div class="phone-flag">
                <img src="assets/images/sa-flag.png"
                    class="flag-img">
              </div>
              <input
                class="phone-number-input"
                type="text"
                inputmode="numeric"
                maxlength="10"
                placeholder="Enter WhatsApp number"
                [(ngModel)]="newContactNumber"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onNewContactPhoneInput($event)">
            </div>
            <div class="validation-message"
                *ngIf="contactWhatsappNumberValidationMessage">
              {{contactWhatsappNumberValidationMessage}}
            </div>
            <label class="save-beneficiary">
                <input type="checkbox"
                      [(ngModel)]="saveContact">
                {{saveContactText}}
              </label>
          </div>
          <!-- BUTTONS -->
          <div class="btns mt-20px">
            <button class="set-authorization-btn"
                (click)="addNewContact()"
                [disabled]="isLoading || !newContactName || !whatsappNumberValid">
                <span *ngIf="!isLoading">Add</span>
                <span *ngIf="isLoading" class="spinner"></span>
              </button>
          </div>
        </div>
      </div>

      <!--  SELECT MAIN PRODUCT CATEGORY -->
      <div *ngIf="showMainProductCategorySection">
        <div class="back-btn"
            (click)="return('beneficiaries')">
          ←
        </div>
        <div class="section-title">
          Select product category
        </div>
        <!-- PRODUCT CATEGORY SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="Search product category"
                [(ngModel)]="categorySearchInput">
          <span class="search-icon">⌕</span>
        </div>
        <div class="bank-scroll">
          <div class="table-list">
            <div class="category-option" *ngFor="let p of filteredMainProductCategories()"
              [class.selected]="selectedMainProductCategory === p"
              (click)="selectMainProductCategory(p)">
              <div class="payment-option-left">
                <span>{{ p.name }}</span>
              </div>
              <div class="icons">
                <div class="tx-icon" *ngFor="let logo of p.logos">
                  <img [src]="'assets/images/' + logo" class="tx-img">
                </div>
              </div>
            </div>
        </div>
        </div>
      </div>

      <!--  SELECT SUB PRODUCT CATEGORY-->
      <div *ngIf="showSubProductCategorySection">
        <div class="back-btn"
            (click)="return('mainCategories')">
          ←
        </div>
        <div class="section-title">
          {{subProductCategoryHeading}}
        </div>
        <!-- SUB PRODUCT SUB CATEGORY SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="{{subProductCategorySearchText}}"
                [(ngModel)]="subProductCategorySearchInput">
          <span class="search-icon">⌕</span>
        </div>
        <div class="bank-scroll">
          <div class="table-list">
            <div class="category-option" *ngFor="let p of filteredSubProductCategoies()"
              [class.selected]="selectedSubProductCategory === p"
              (click)="selectSubProductCategory(p)">
              <div class="payment-option-left">
                <span>{{ p.name }}</span>
              </div>
              <div class="tx-icon">
                  <img [src]="'assets/images/' + p.logo"
                      class="tx-img">
                </div>
            </div>
          </div>
        </div>
      </div>

      <!--  SELECT PRODUCT TYPE-->
      <div *ngIf="showProductTypeSection">
        <div class="back-btn"
            (click)="return('subCategories')">
          ←
        </div>
        <div class="section-title">
          {{productTypeHeading}}
        </div>
        <!--  PRODUCT TYPE SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="{{productTypeSearchText}}"
                [(ngModel)]="productTypeSearchInput">
          <span class="search-icon">⌕</span>
        </div>
        <div class="bank-scroll">
          <div class="table-list">
            <div class="category-option" *ngFor="let p of filteredProductTypes()"
              [class.selected]="selectedProductType === p"
              (click)="selectProductType(p)">
              <div class="payment-option-left">
                <span>{{ p.type }}</span>
              </div>
              <div class="icons">
                <div class="tx-icon">
                  <img [src]="'assets/images/' + p.logo" class="tx-img">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--  SELECT PRODUCT DURATION-->
      <div *ngIf="showProductDurationSection">
        <div class="back-btn"
            (click)="return('productTypes')">
          ←
        </div>
        <div class="section-title">
          {{productDurationHeading}}
        </div>
        <!-- SUB PRODUCT DURATION SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="{{productDurationSearchText}}"
                [(ngModel)]="productDurationSearchInput">
          <span class="search-icon">⌕</span>
        </div>
        <div class="bank-scroll">
          <div class="table-list">
            <div class="category-option" *ngFor="let p of filteredProductDurations()"
              [class.selected]="selectedProductDuration === p"
              (click)="selectProductDuration(p)">
              <div class="payment-option-left">
                <span>{{ p.duration }}</span>
              </div>
              </div>
          </div>
        </div>
      </div>

      <!--  SELECT PRODUCT -->
      <div *ngIf="showProductsSection">
        <div class="back-btn"
            (click)="return('fromProducts')">
          ←
        </div>
        <div class="section-title">
          Select product
        </div>
        <!-- PRODUCT SEARCH INPUT -->
        <div class="search-box">
          <input class="search-input"
                placeholder="Search product"
                [(ngModel)]="productSearchInput">
          <span class="search-icon">⌕</span>
        </div>
        <div class="bank-scroll">
          <div class="table-list">
            <div class="category-option" *ngFor="let p of filteredProducts()"
              [class.selected]="selectedProduct === p"
              (click)="selectProduct(p)">
              <div class="payment-option-left">
                <span>{{ p.name }}</span>
              </div>
              <div class="tx-icon">
                  <img [src]="'assets/images/' + p.logo"
                      class="tx-img">
                </div>
            </div>
          </div>
        </div>
      </div>

      <!--  ELECTRICITY METER -->
      <div *ngIf="showElectricityMeterSection">
        <div *ngIf="showElectricityMeters">
        <div class="back-btn"
            (click)="return('mainCategories')">
          ←
        </div>
        <div class="title">Select Electricity Meter</div>
          <!-- ADD METER BUTTON -->
          <div class="edit-only-top-bar" >
            <div class="top-actions">
              <button class="icon-btn "
                      (click)="onAddNewElectricityMeter();">
                <span class="icon-text">+</span>
              </button>
            </div>
          </div>
          <!-- METER SEARCH INPUT -->
          <div class="search-box">
            <input class="search-input"
                  placeholder="Search meter"
                  [(ngModel)]="searchInput">
            <span class="search-icon">⌕</span>
          </div>
          <!-- METERS LIST-->
          <div class="pay-scroll">
            <div class="table-list">
              <div class="row" *ngFor="let c of filteredElectricityMeters()"
                (click)="selectElectricityMeter(c)">
                <div class="contact-details">
                  <strong class="tx-title">{{c.meterName}}</strong>
                  <small class="tx-number">{{c.meterNumber}}</small>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ADD METER -->
        <div  *ngIf="showAddNewElectricityMeter">
        <div class="back-btn"
                (click)="closeAddMeter()">
              ←
            </div>
          <div class="section-title">
            New electricity meter
          </div>
          <!-- NAME -->
          <div>
            <div class="field">
              <label class="field-label">Meter Name</label>
              <input class="input"
                placeholder="Enter name"
                [(ngModel)]="newMeterName"
                (ngModelChange)="meterNameValidationMessage=''">
              <div class="validation-message" *ngIf="meterNameValidationMessage">
                {{meterNameValidationMessage}}
              </div>
            </div>
            <!-- METER NUMBER -->
            <div class="field">
              <label class="field-label">Meter Number</label>
                <input
                class="input"
                type="text"
                inputmode="numeric"
                maxlength="20"
                placeholder="Enter meter number"
                [(ngModel)]="newMeterNumber"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onNewMeterNumberInput($event)">
              <div class="validation-message" *ngIf="meterNumberValidationMessage">
                {{meterNumberValidationMessage}}
              </div>
            </div>
            <label class="save-beneficiary">
                <input type="checkbox"
                      [(ngModel)]="saveElectricityMeter">
                Save meter
              </label>
          </div>
          <!-- BUTTONS -->
          <div class="btns">
            <button class="set-authorization-btn"
                (click)="addNewElectricityMeter()"
              [disabled]="isLoading || !newMeterName || !meterNumberValid">
                <span *ngIf="!isLoading">Add</span>
                <span *ngIf="isLoading" class="spinner"></span>
              </button>
          </div>
        </div>
      </div>

      <!--  TRANSACTION SUMMARY -->
      <div *ngIf="showTransactionSummary">
        <div class="back-btn" (click)="return('fromTransactionSummary')">
          ←
        </div>
        <div *ngIf="showAmountInput">
          <div class="grey-label">
            Amount
          </div>
          <!-- limits -->
          <div class="limits" *ngIf="showAmountLimits">
            <div>{{dailyLimit}}</div>
            <div>{{monthlyLimit}}</div>
          </div>
          <!-- amount -->
          <div class="amount-box">
            <div class="currency">R</div>
            <input
                  class="amount-input"
                  type="text"
                  inputmode="numeric"
                  maxlength="6"
                  placeholder="Enter amount"
                  [(ngModel)]="amount"
                  (keydown)="allowOnlyNumbers($event)"
                  (ngModelChange)="onAmountInput();">
          </div>
        </div>
        <div class="validation-message" *ngIf="amountValidationMessage">
          <div>{{amountValidationMessage}}</div>
        </div>
        <div class="grey-label">
          Transaction Summary
        </div>
      <div class="transactionSummary-card">
          <div class="detail-row" *ngIf="transactionTypeSummary">
            <div class="label">Transaction Type</div>
            <div class="colon"></div>
            <div class="value">{{transactionTypeSummary}}</div>
          </div>
          <div class="detail-row" *ngIf="beneficiarySummary">
            <div class="label">Beneficiary</div>
            <div class="colon"></div>
            <div class="value">{{beneficiarySummary}}</div>
          </div>
          <div class="detail-row" *ngIf="payerSummary">
            <div class="label">Payer</div>
            <div class="colon"></div>
            <div class="value">{{payerSummary}}</div>
          </div>
          <div class="detail-row" *ngIf="productTypeSummary">
            <div class="label">{{productTypeText}}</div>
            <div class="colon"></div>
            <div class="value">{{productTypeSummary}}</div>
          </div>
          <div class="detail-row" *ngIf="productSummary">
            <div class="label">Product</div>
            <div class="colon"></div>
            <div class="value">{{productSummary}}</div>
          </div>
          <div class="detail-row" *ngIf="electricityMeterSummary">
            <div class="label">Meter</div>
            <div class="colon"></div>
            <div class="value">{{electricityMeterSummary}}</div>
          </div>
          <div class="detail-row" *ngIf="amountSummary">
            <div class="label">Amount</div>
            <div class="colon"></div>
            <div class="value">{{amountSummary}}</div>
          </div>
          <div class="detail-row" *ngIf="serviceFeeSummary">
            <div class="label">Service Fee</div>
            <div class="colon"></div>
            <div class="value">{{serviceFeeSummary}}</div>
          </div>
          <div class="detail-row" *ngIf="amountSummary">
            <div class="totalAmountToPay-card" >
              <div class="payment-option-left">
                <span>Total Amount</span>
              </div>
              <div class="colon"></div>
                <span
                  class="totalAmount-span"
                  [ngClass]="{
                    'amount-valid': amountValid,
                    'amount-invalid': !amountValid
                  }">
                  {{ amountSummary }}
                </span>
            </div>
          </div>
        </div>
        <!-- BUTTONS -->
        <div class="authorize-btns" *ngIf="showAuthorizeButton">
          <button class="authorize-btn"
            (click)="AuthorizeTransaction()"
            [disabled]="isLoading || !amount || amount <= 0 || amount < minAmount || amount > maxAmount || amount > walletBalance">
            <span *ngIf="!isLoading">{{processButtonText}}</span>
            <span *ngIf="isLoading" class="spinner"></span>
          </button>
        </div>
      </div>

      <!-- AUTHORIZE POPUP -->
        <div class="overlay" *ngIf="showAuthorizePopup">
          <div class="alert-modal">
            <div class="section-title">
              Authorize Transaction
            </div>
            <p class="pin-text">
              Enter your 4-digit PIN.
            </p>
            <div class="pin-warning-text"  *ngIf="authorizationPinValidationMessage">
              {{authorizationPinValidationMessage}}
            </div>
            <div class="pin-wrapper">
            <input
                #pinInput
                class="hidden-pin-input"
                type="password"
                inputmode="numeric"
                maxlength="4"
                autocomplete="one-time-code"
                [(ngModel)]="authorizationPin"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onPinChange($event)">

              <div class="pin-wrapper">
                <!-- Hidden input -->
              <input
                #pinInput
                class="hidden-pin-input"
                type="password"
                inputmode="numeric"
                maxlength="4"
                autocomplete="one-time-code"
                [(ngModel)]="authorizationPin"
                (keydown)="allowOnlyNumbers($event)"
                (ngModelChange)="onPinChange($event)">

                

                <!-- Click anywhere to focus -->
                <div class="pin-display" (click)="pinInput.focus()">
                  <div class="pin-circle"
                      [class.filled]="authorizationPin.length > 0"
                      [class.active]="authorizationPin.length === 0">
                    {{ authorizationPin.length > 0 ? '•' : '' }}
                  </div>

                  <div class="pin-circle"
                      [class.filled]="authorizationPin.length > 1"
                      [class.active]="authorizationPin.length === 1">
                    {{ authorizationPin.length > 1 ? '•' : '' }}
                  </div>

                  <div class="pin-circle"
                      [class.filled]="authorizationPin.length > 2"
                      [class.active]="authorizationPin.length === 2">
                    {{ authorizationPin.length > 2 ? '•' : '' }}
                  </div>

                  <div class="pin-circle"
                      [class.filled]="authorizationPin.length > 3"
                      [class.active]="authorizationPin.length === 3">
                    {{ authorizationPin.length > 3 ? '•' : '' }}
                  </div>
                </div>
              </div>
            </div>
          <div class="btns" *ngIf="!isLoading">
              <button
                class="cancel"
                (click)="closeAuthorizePopup()">
                Cancel
              </button>
              <button
                class="primary"
                [disabled]="authorizationPin.length !== 4"
                (click)="confirmAuthorization()">
                Authorize
              </button>
            </div>
            <div class="spinner-container" *ngIf="isLoading">
              <span class="spinner"></span>
            </div>
        </div>
      </div>
    </div>

    <div class="overlay" *ngIf="showErrorPopup">
      <div class="alert-modal">
        <p class="pin-text">
            {{ errorMessage }}
        </p>
        <div class="btns">
          <button
            class="primary"
            (click)="closeErrorPopup()">
            Ok
          </button>
        </div>
      </div>
    </div>
  `
})
export class BuyComponent{
  sessionToken = '';
  userId = '';
  whatsAppUrl = environment.whatsapp_url;
  isLoading = false;
  isLoadingPageContent = true;
  showPageContent = false;
  showErrorPopup = false;
  errorMessage = '';
  walletBalance = 0;
  userNumber = '';
  userDisplayNumber = '';
  contacts: any[] = [];
  mainProductCategories: any[] = [];
  products: any[] = [];
  subProductCategories: any[] = [];
  productTypes: any[] = [];
  productDurations: any[] = [];
  electricityMeterAccounts: any[] = [];

 constructor(private router: Router,
                       private sessionService: SessionService,
                       private buyService: BuyService,
                       private userElectricityMeterService: UserElectricityMeterService,
                       private contactElectricityMeterService: ContactElectricityMeterService,
                       private contactService: ContactService) {}
                       
   ngOnInit() {
     this.sessionToken = this.sessionService.getSession();
     if (!this.sessionToken) {
       this.errorMessage = 'Request failed, please reload page and try again.';
       this.showErrorPopup = true;
       return;
     }
     this.walletBalance = this.sessionService.getWalletBalance();
     this.getBuyData();
   }
   getBuyData() {
     this.buyService
     .getBuyData(this.sessionToken)
     .subscribe({
         next: response => {
           this.contacts =  response.beneficiaries.$values;
           this.mainProductCategories =  response.mainProductCategories.$values.map((c: any) => ({ ...c, logos: c.logos.$values}));
           this.userNumber = response.userNumber;
           this.userDisplayNumber = response.userDisplayNumber;
           this.changeContactsList(this.buyMode);

          this.isLoadingPageContent = false;
          this.showPageContent = true;
         },
         error: err => {
           if (err.status === 401 || err.status === 404) {
             this.userId = this.sessionService.getUserId();
             this.router.navigateByUrl(
               '/Login/' + this.userId,
               { replaceUrl: true }
             );
             return;
           }
           this.errorMessage = err.error?.message ?? 'Unable to load page.';
           this.showErrorPopup = true;
           this.isLoadingPageContent = false;
         }
       },
     );
   }
  // =====================================================
  // BUY MODE
  // =====================================================
  buyMode = 'buy';

  changeBuyMode(mode:string){
    this.contactSearchInput = '';
    if(mode === 'buy'){
      this.selectContactSectionTopHeading = 'Select beneficiary';
      this.contactSearchInputPlaceholder = 'Search beneficiary';
      this.transactionTypeSummary = 'Purchase';
      this.categorySearchInput = '';
      this.productSearchInput = '';
      this.subProductCategorySearchInput = '';
      this.productTypeSearchInput = '';
      this.productDurationSearchInput = '';
      this.processButtonText = 'Authorize';
    }
    else if(mode === 'payforme'){
      this.selectContactSectionTopHeading = 'Select payer';
      this.contactSearchInputPlaceholder = 'Search payer';
      this.transactionTypeSummary = 'Pay for me';
      this.processButtonText = 'Send';
    }
   this.buyMode = mode;
   this.changeContactsList(mode);

  }
  // =====================================================
  // CONTACT
  // =====================================================
  newContactName = '';
  newContactNumber = '';
  newContactFormatedNumber = '';
  newContactDisplayNumber = '';
  contactNameValidationMessage = '';
  contactWhatsappNumberValidationMessage = '';
  saveContactText = '';
  saveContact = false;
  addNewContactSectionTopHeading = '';
  showAddNewContact = false;
  selectedContact:any = null;
  whatsappNumberValid = false;
  selectContactSectionTopHeading = 'Select beneficiary';
  showBeneficiarySection = true;

  changeContactsList(mode:string){
    // Remove any existing "Me" contact first
  this.contacts = this.contacts.filter(c => c.name !== 'Me');

  if (mode === 'buy') {
    this.contacts.unshift({
      name: 'Me',
      displayNumber: this.userDisplayNumber,
      number: this.userNumber,
      isActive: true
    });
  }
  }
  selectContact(contact:any){
      this.selectedContact = contact;
      this.showBeneficiarySection = false;
      this.showMainProductCategorySection = true;

      if(this.buyMode === 'buy'){
        this.beneficiarySummary = contact.name + ' ' + '('+ contact.displayNumber + ')';
      }
      else if(this.buyMode === 'payforme'){
        this.beneficiarySummary = 'Me ' + '('+ this.userDisplayNumber + ')';
        this.payerSummary =  contact.name + ' ' + '('+ contact.displayNumber + ')';
    }
  }
  filteredContacts() {
    let contacts = this.contacts;
    const search = this.contactSearchInput.toLowerCase();
    return contacts.filter(x =>
      x.name.toLowerCase().includes(search) ||
       x.number.toLowerCase().includes(search) ||
      x.displayNumber.toLowerCase().includes(search)
    );
  }
  onAddNewContact(){
     if(this.buyMode === 'buy'){
      this.addNewContactSectionTopHeading = 'New beneficiary';
      this.saveContactText = 'Save beneficiary'
    }
    else if(this.buyMode === 'payforme'){
      this.addNewContactSectionTopHeading = 'New payer';
      this.saveContactText = 'Save payer'
    }
    this.showAddNewContact = true;
  }
  closeAddNewContact(){
    this.selectContactSectionTopHeading = 'Select beneficiary';
    if(this.buyMode === 'buy'){
      this.selectContactSectionTopHeading = 'Select beneficiary';
    }
    else if(this.buyMode === 'payforme'){
      this.selectContactSectionTopHeading = 'Select payer';
    }
    this.showAddNewContact = false;
    this.newContactName = '';
    this.newContactNumber = '';
    this.contactNameValidationMessage = '';
    this.contactWhatsappNumberValidationMessage = '';
  }
  onNewContactPhoneInput(){
    const validation =this.validatePhoneNumber();
       if(this.newContactNumber){
        if(!validation.isValid){
            this.contactWhatsappNumberValidationMessage = validation.message;
            this.whatsappNumberValid = false;
          }
          else{
            this.contactWhatsappNumberValidationMessage = '';
            this.whatsappNumberValid = true;
          }
      }
      else
        this.whatsappNumberValid = false;
  }
  addNewContact(){
    let hasError = false;
    this.contactNameValidationMessage = '';
    this.contactWhatsappNumberValidationMessage = '';

    // NAME
    if(!this.newContactName.trim()){
      this.contactNameValidationMessage = 'Name is required';
      hasError = true;
    }
    // WHATSAPP NUMBER
    if(!this.newContactNumber.trim()){
      this.contactWhatsappNumberValidationMessage = 'WhatsApp number is required';
      hasError = true;
    }
    else{
      const validation =this.validatePhoneNumber();
      if(!validation.isValid){
        this.contactWhatsappNumberValidationMessage = validation.message;
        hasError = true;
      }
    }      
    if(hasError){
      return;
    }

    if(this.saveContact){
      this.isLoading = true;
      this.contactService
      .postContact(this.sessionToken,
                this.newContactName,
                this.newContactFormatedNumber, 
                this.newContactDisplayNumber, 
                'Buy')
      .pipe(
            finalize(() => this.isLoading = false)
          )
      .subscribe({
          next: response => {
            this.contacts = response.activeContacts.$values;
            this.changeContactsList(this.buyMode);

            this.selectContact(response.newContact);
            return;
          },
          error: err => {
             if (err.status === 401 || err.status === 404) {
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
            return;
          }
        },
      );
    }
    else{
      this.showBeneficiarySection = false;
      this.showMainProductCategorySection = true;
    }
  }
  validatePhoneNumber(){
    let mobileRegexPattern = /^(0|\+27|27)[5-8][0-9][0-9]{7}$/;
    let phoneNumber = this.newContactNumber.trim().replace(/\s+/g, '');
    if(!mobileRegexPattern.test(phoneNumber)){
      return {
        isValid:false,
        message:'Invalid WhatsApp number'
      };
    }
    phoneNumber = phoneNumber.replace(/\D/g,'');// REMOVE NON NUMBERS
    if(phoneNumber.startsWith('0')){// CONVERT 076... -> 276...
      phoneNumber = phoneNumber.substring(1);
      phoneNumber = '27' + phoneNumber;
    }
    if(phoneNumber == this.userNumber){
      return {
        isValid:false,
        message:'You cannot add your number as a contact'
      };
    }
    // DISPLAY FORMAT
    let displayNumber = '0' + phoneNumber.substring(2);
    this.newContactFormatedNumber = phoneNumber;
    this.newContactDisplayNumber = displayNumber;
    return {
      isValid:true,
      message:'',
      formattedNumber:phoneNumber,
      displayNumber:displayNumber
    };
  }
 // =====================================================
  // ELECTRICITY METER
  // =====================================================
   meterNameValidationMessage = '';
  meterNumberValidationMessage = '';
  newMeterName = '';
  newMeterNumber = '';
  showAddNewElectricityMeter = false;
  meterNumberValid = false;
  saveElectricityMeter = false;
   selectedElectricityMeter:any = null;


  selectElectricityMeter(meter:any){
      this.selectedElectricityMeter = meter;
      this.showElectricityMeterSection = false;
      this.showTransactionSummary = true;
      this.isLoading = false;
      this.showAmountInput = true;
      this.productSummary = this.selectedMainProductCategory.name;
      this.electricityMeterSummary = meter.meterName + ' ' + '('+ meter.meterNumber + ')';
  }
 onAddNewElectricityMeter() {
    this.showElectricityMeters = false;
    this.showAddNewElectricityMeter = true;
    this.newMeterName = '';
    this.newMeterNumber = '';
    this.isLoading = false;
  }
   closeAddMeter(){
    this.showAddNewElectricityMeter = false;
    this.showElectricityMeters = true;
    this.newMeterName = '';
    this.newMeterNumber = '';
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';
  }
  onNewMeterNumberInput(){
   const validation =this.validateMeterNumber();
    if(this.newMeterNumber){
      if(!validation.isValid){
          this.meterNumberValidationMessage = validation.message;
          this.meterNumberValid = false;
        }
        else{
          this.meterNumberValidationMessage = '';
          this.meterNumberValid = true;
        }
    }
    else
      this.meterNumberValid = false;
  }
 validateMeterNumber() {
  const meterNumberRegex = /^\d{10,12}$/;

  if (!meterNumberRegex.test(this.newMeterNumber)) {
    return {
      isValid: false,
      message: 'Enter a valid 10 - 12 digit meter number'
    };
  }

  return {
    isValid: true,
    message: ''
  };
}
  addNewElectricityMeter(){
    let hasError = false;
    this.meterNameValidationMessage = '';
    this.meterNumberValidationMessage = '';

    // NAME
    if(!this.newMeterName.trim()){
      this.meterNameValidationMessage = 'Meter name is required';
      hasError = true;
    }
    // METER NUMBER
    if(!this.newMeterNumber.trim()){
      this.meterNumberValidationMessage = 'Meter number is required';
      hasError = true;
    }
    else{
      const validation =this.validateMeterNumber();
      if(!validation.isValid){
        this.meterNumberValidationMessage = validation.message;
        hasError = true;
      }
    }

    if(hasError){
      return;
    }

    if(this.saveElectricityMeter){
      this.isLoading = true;

      if(this.selectedContact.number === this.userNumber){
        this.userElectricityMeterService
        .postElectricityMeter(this.sessionToken,
                  this.newMeterName,
                  this.newMeterNumber, 
                  'Buy')
        .pipe(
              finalize(() => this.isLoading = false)
            )
        .subscribe({
            next: response => {
              this.electricityMeterAccounts = response.activeMeters.$values;
              this.selectElectricityMeter(response.newMeter);
              return;
            },
            error: err => {
              if (err.status === 401 || err.status === 404) {
                this.userId = this.sessionService.getUserId();
                this.router.navigateByUrl(
                  '/Login/' + this.userId,
                  { replaceUrl: true }
                );
                return;
              }
              this.errorMessage = err.error?.message ?? 'Unable to load page.';
              this.showErrorPopup = true;
              return;
            }
          },
        );
      }
      else{
        this.contactElectricityMeterService
        .postElectricityMeter(this.sessionToken,
                  this.selectedContact.id,
                  this.newMeterName,
                  this.newMeterNumber, 
                  'Buy')
        .pipe(
              finalize(() => this.isLoading = false)
            )
        .subscribe({
            next: response => {
              this.electricityMeterAccounts = response.activeMeters.$values;
              this.selectElectricityMeter(response.newMeter);
              return;
            },
            error: err => {
              if (err.status === 401 || err.status === 404) {
                this.userId = this.sessionService.getUserId();
                this.router.navigateByUrl(
                  '/Login/' + this.userId,
                  { replaceUrl: true }
                );
                return;
              }
              this.errorMessage = err.error?.message ?? 'Unable to load page.';
              this.showErrorPopup = true;
              return;
            }
          },
        );
      }
    }
    else{
      this.showElectricityMeterSection = false;
      this.showTransactionSummary = true;
      this.isLoading = false;
      this.showAmountInput = true;
      this.productSummary = this.selectedMainProductCategory.name;
      this.electricityMeterSummary = `${this.newMeterName} (${this.newMeterNumber})`;
    }
  }
   // =====================================================
  // PRODUCT CATEGORY
  // =====================================================
  selectedMainProductCategory:any = null;
  showMainProductCategorySection = false;

  selectMainProductCategory(category:any){
    this.selectedMainProductCategory = category;

    this.isLoading = true;
    this.buyService
      .getProductCategoryData(this.sessionToken,
                this.selectedMainProductCategory.id,
                '',
                '',
                '',
                this.selectedContact?.id ?? '',
                this.buyMode)
      .subscribe({
          next: response => {
            if(response.body.subProductCategories.$values.length > 0){
                
              this.subProductCategories = response.body.subProductCategories.$values;
      
              this.showMainProductCategorySection = false;
              this.showSubProductCategorySection = true;

              this.subProductCategoryHeading = response.body.heading;
              this.subProductCategorySearchText = response.body.searchText;
              this.categorySearchInput = '';
            }
            else if(response.body.products.$values.length > 0){
                
              this.products = response.body.products.$values;
              this.amountValidationMessage = '';
      
              this.showMainProductCategorySection = false;
              this.showProductsSection = true;
              this.categorySearchInput = '';
            }
            else if(this.selectedMainProductCategory.name === 'Prepaid Electricity'){
              this.productTypeSummary = '';
               if(response.body.productSelected){
                  this.selectedProduct = response.body.productSelected;
                  this.minAmount = this.selectedProduct.minAmount;
                  this.maxAmount = this.selectedProduct.maxAmount;
               }

              this.electricityMeterAccounts = response.body.electricityMeters.$values;

              this.showMainProductCategorySection = false;
              this.showElectricityMeterSection = true;
              this.categorySearchInput = '';
            }
            return;
          },
          error: err => {
             if (err.status === 401 || err.status === 404) {
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            this.errorMessage = err.error?.message ?? 'Unable to load page.';
            this.showErrorPopup = true;
            return;
          }
        },
      );
  }
  selectSubProductCategory(category:any){
    this.selectedSubProductCategory = category;

    this.buyService
    .getProductCategoryData(this.sessionToken,
                            '',
                            this.selectedSubProductCategory.id,
                            '',
                            '',
                            '',
                            this.buyMode)
    .subscribe({
        next: response => {
          if(this.selectedSubProductCategory.name === 'Eezi Airtime'){
             if(response.body.productSelected)
              this.selectProduct(response.body.productSelected)
          }
          else if(response.body.productTypes.$values.length > 0){
              
            this.productTypes = response.body.productTypes.$values;
    
            this.showSubProductCategorySection = false;
            this.showProductTypeSection = true;

            this.productTypeHeading = response.body.heading  + ` (${this.selectedSubProductCategory.name})`;
            this.productTypeSearchText = response.body.searchText;
            this.subProductCategorySearchInput = '';
          }
          else if(response.body.products.$values.length > 0){
            this.products = response.body.products.$values;
            this.amountValidationMessage = '';
    
            this.showSubProductCategorySection = false;
            this.showProductsSection = true;
            this.categorySearchInput = '';

            this.productTypeText = 'Product Category';
            this.productTypeSummary = `${this.selectedMainProductCategory.name} (${this.selectedSubProductCategory.name})`;
          }
          return;
        },
        error: err => {
            if (err.status === 401 || err.status === 404) {
            this.userId = this.sessionService.getUserId();
            this.router.navigateByUrl(
              '/Login/' + this.userId,
              { replaceUrl: true }
            );
            return;
          }
          this.errorMessage = err.error?.message ?? 'Unable to load page.';
          this.showErrorPopup = true;
          return;
        }
      },
    );
  }
  selectProductType(type:any){
    this.selectedProductType = type;
    
    this.buyService
    .getProductCategoryData(this.sessionToken,
                            '',
                            this.selectedSubProductCategory.id,
                            this.selectedProductType.id,
                            '',
                            '',
                            this.buyMode)
    .subscribe({
        next: response => {
          if(this.selectedProductType.type === 'Airtime'){
            this.productTypeSummary = '';
            if(response.body.productSelected)
              this.selectProduct(response.body.productSelected)
          }
          else if(response.body.productDurations.$values.length > 0){
            this.productDurations = response.body.productDurations.$values;
    
            this.showProductTypeSection = false;
            this.showProductDurationSection = true;

            this.productDurationHeading = response.body.heading + ` (${this.selectedSubProductCategory.name} ${this.selectedProductType.type})`;
            this.productDurationSearchText = response.body.searchText;
            this.productTypeSearchInput = '';
          }
          return;
        },
        error: err => {
            if (err.status === 401 || err.status === 404) {
            this.userId = this.sessionService.getUserId();
            this.router.navigateByUrl(
              '/Login/' + this.userId,
              { replaceUrl: true }
            );
            return;
          }
          this.errorMessage = err.error?.message ?? 'Unable to load page.';
          this.showErrorPopup = true;
          return;
        }
      },
    );
  }
  selectProductDuration(duration:any){
  this.selectedProductDuration = duration;
  this.buyService
    .getProductCategoryData(this.sessionToken,
                            '',
                            this.selectedSubProductCategory.id,
                            this.selectedProductType.id,
                            this.selectedProductDuration.id,
                            '',
                            this.buyMode)
    .subscribe({
        next: response => {
          if(response.body.products.$values.length > 0){
              
            this.products = response.body.products.$values;
            this.amountValidationMessage = '';
    
            this.showProductDurationSection = false;
            this.showProductsSection = true;

            this.productDurationSearchInput = '';
            this.productTypeText = 'Product Type';
            this.productTypeSummary = `${this.selectedSubProductCategory.name} ${this.selectedProductType.type} (${duration.duration})`;
          }
          return;
        },
        error: err => {
            if (err.status === 401 || err.status === 404) {
            this.userId = this.sessionService.getUserId();
            this.router.navigateByUrl(
              '/Login/' + this.userId,
              { replaceUrl: true }
            );
            return;
          }
          this.errorMessage = err.error?.message ?? 'Unable to load page.';
          this.showErrorPopup = true;
          return;
        }
      },
    );
  }
  // =====================================================
  // PRODUCTS
  // =====================================================
  selectedProduct:any = null;
  selectedSubProductCategory:any = null;
  selectedProductType:any = null;
  selectedProductDuration:any = null;
  showProductsSection = false;
  showSubProductCategorySection = false;
  showProductTypeSection = false;
  showProductDurationSection = false;
  showElectricityMeterSection = false;
  showElectricityMeters = true;

  selectProduct(product:any){
    this.productSearchInput = '';
    this.amountValidationMessage = '';
    this.selectedProduct = product;
    this.showProductsSection = false;
    this.showTransactionSummary = true;
    this.isLoading = false;
    this.productSummary = product.displayName;
  
    if(this.selectedProductType){
      if(this.selectedProductType.type === 'Airtime'){
        this.productTypeSummary = '';
          this.showProductTypeSection = false;
          this.productSummary = `${this.selectedSubProductCategory.name} ${this.selectedProductType.type}`;
        }
    }
    else if(this.selectedSubProductCategory){
       if(this.selectedSubProductCategory.name === 'Eezi Airtime'){
          this.showSubProductCategorySection = false;
       }
    }
    else{
      this.productTypeText = 'Product Category';
      this.productTypeSummary = `${this.selectedMainProductCategory.name}`;
    }

    if(product.fixedAmount){
      this.isLoading = false;
        this.showAmountInput = false;
        this.amount = product.minAmount;
        this.amountSummary = `R${this.amount}`;
        this.serviceFeeSummary = 'R0.00';

        if (this.amount > this.walletBalance) {
          this.amountValidationMessage = `Insufficient funds to cover amount`;
          this.amountValid = false;
        return;
      }
      this.amountValid = true;
    }
    else{
      this.showAmountInput = true;
      if(this.selectedProduct.hasLimits){
        this.showAmountLimits = true;
        if(this.selectedProduct.dailyLimit){
          this.dailyLimit = `Daily limit: R${this.selectedProduct.dailyLimit}`;
        }
        if(this.selectedProduct.monthlyLimit){
          
          this.monthlyLimit = `Monthly limit: R${this.selectedProduct.monthlyLimit}`;
        }
      }
      else{
          this.showAmountLimits = false;
          this.dailyLimit = null;
          this.monthlyLimit = null;
        }
    }
    this.minAmount = this.selectedProduct.minAmount;
    this.maxAmount = this.selectedProduct.maxAmount;
  }
   
   filteredMainProductCategories() {
    let categories = this.mainProductCategories;
    const search = this.categorySearchInput.toLowerCase();
    return categories.filter(x =>
      x.name.toLowerCase().includes(search)
    );
  }
   filteredSubProductCategoies() {
    let categories = this.subProductCategories;
    const search = this.subProductCategorySearchInput.toLowerCase();
    return categories.filter(x =>
      x.name.toLowerCase().includes(search)
    );
  }
   filteredProductTypes() {
    let types = this.productTypes;
    const search = this.productTypeSearchInput.toLowerCase();
    return types.filter(x =>
      x.type.toLowerCase().includes(search)
    );
  }
   filteredProductDurations() {
    let durations = this.productDurations;
    const search = this.productDurationSearchInput.toLowerCase();
    return durations.filter(x =>
      x.duration.toLowerCase().includes(search)
    );
  }
  filteredProducts() {
    let products = this.products;
    const search = this.productSearchInput.toLowerCase();
    return products.filter(x =>
      x.name.toLowerCase().includes(search)
    );
  }
   filteredElectricityMeters(){
    let accounts = this.electricityMeterAccounts;
    const search = this.electricityMeterSearchInput.toLowerCase();
    return accounts.filter(x =>
      x.meterName.toLowerCase().includes(search) ||
      x.meterNumber.toLowerCase().includes(search)
    );
  }
  // =====================================================
  // TRANSACTION SUMMARY
  // =====================================================
  showTransactionSummary = false;
  transactionTypeSummary = 'Purchase';
  beneficiarySummary = '';
  payerSummary = '';
  productSummary = '';
  electricityMeterSummary = '';
  amountSummary = '';
  serviceFeeSummary = ''
  productTypeSummary = '';
  productTypeText = '';
  // =====================================================
  // AUTHORIZATION
  // =====================================================
  showAuthorizePopup = false;
  authorizationPin = '';
  showAuthorizeButton = true;
  authorizationPinValidationMessage = '';

  onPinChange(value: string): void {
    this.authorizationPin = value.replace(/\D/g, '').slice(0, 4);
  }
   AuthorizeTransaction() {
    if(this.buyMode === 'buy'){
      this.authorizationPinValidationMessage = '';
      this.showAuthorizeButton = false;
      this.authorizationPin = '';
      this.showAuthorizePopup = true;
    }
    else if(this.buyMode === 'payforme'){
      this.isLoading = true;
      this.buyService
      .postPayForMe(this.sessionToken,
                    this.selectedProduct?.id ?? this.selectedMainProductCategory.id,
                    this.selectedContact?.id ?? '',
                    this.newContactName ?? '', 
                    this.newContactFormatedNumber ?? '', 
                    this.newContactDisplayNumber ?? '',
                    this.selectedElectricityMeter?.id ?? '',
                    this.newMeterName ?? '',
                    this.newMeterNumber ?? '',
                    this.amount)
      .pipe(
            finalize(() => this.isLoading = false)
          )
      .subscribe({
          next: response => {
            this.showAuthorizePopup = false;
            window.location.href = this.whatsAppUrl;
          },
          error: err => {
            this.authorizationPin = '';
            if (err.status === 401 || err.status === 404) {
              this.showAuthorizePopup = false;
                this.userId = this.sessionService.getUserId();
                this.router.navigateByUrl(
                  '/Login/' + this.userId,
                  { replaceUrl: true }
                );
                return;
              }
              else{
                this.showAuthorizePopup = false;
                this.errorMessage = err.error?.message ?? 'Unable to load page.';
                this.showErrorPopup = true;
              }
          }
        },
      );
    }
  }
  closeAuthorizePopup() {
    this.showAuthorizeButton = true;
    this.showAuthorizePopup = false;
    this.authorizationPin = '';
  }
  confirmAuthorization() {
    this.isLoading = true;
    this.buyService
    .postBuy(this.sessionToken,
                  this.authorizationPin,
                  this.selectedContact?.id ?? '',
                  this.newContactName ?? '', 
                  this.newContactFormatedNumber ?? '', 
                  this.newContactDisplayNumber ?? '',
                  this.selectedProduct?.id ?? this.selectedMainProductCategory.id,
                  this.selectedElectricityMeter?.id ?? '',
                  this.newMeterName ?? '',
                  this.newMeterNumber ?? '',
                  this.amount)
    .pipe(
          finalize(() => this.isLoading = false)
        )
    .subscribe({
        next: response => {
          this.authorizationPin = '';
          this.showAuthorizePopup = false;
          window.location.href = this.whatsAppUrl;
        },
        error: err => {
          this.authorizationPin = '';
          if (err.status === 401 || err.status === 404) {
            this.showAuthorizePopup = false;
              this.userId = this.sessionService.getUserId();
              this.router.navigateByUrl(
                '/Login/' + this.userId,
                { replaceUrl: true }
              );
              return;
            }
            if (err.status === 501) {
              this.authorizationPinValidationMessage = err.error?.message;
              return;
            }
            else{
              this.showAuthorizePopup = false;
              this.errorMessage = err.error?.message ?? 'Unable to load page.';
              this.showErrorPopup = true;
            }
        }
      },
    );
  }
  // =====================================================
  // AMOUNT
  // =====================================================
  amountValidationMessage = '';
  amount: number | null = null;
  serviceFee: number | null = null;
  dailyLimit = '';
  monthlyLimit = '';
  showAmountLimits = false;
  minAmount = 0;
  maxAmount = 0;
  showAmountInput = false;
  amountValid = false;
  
  onAmountInput(){
    this.amountValidationMessage = '';
     this.amountValid = false;
     this.serviceFeeSummary = '';

    if (this.amount == null) {
      this.amountSummary = '';
      return;
    }
    else if (this.amount < this.minAmount) {
      this.amountValidationMessage =
      `Minimum amount is R${this.minAmount}`;
      this.amountSummary = '';
    return;
    }
    else if (this.amount > this.maxAmount) {
      this.amountValidationMessage =
        `Maximum amount is R${this.maxAmount}`;
        this.amountSummary = '';
      return;
    }
    else{
      this.amountSummary = `R${this.amount}`;
       this.serviceFeeSummary = 'R0.00';
      if (this.amount > this.walletBalance) {
          this.amountValidationMessage = `Insufficient funds to cover amount`;
        return;
      }
      this.amountValid = true;
    }
  }
  // =====================================================
  // COMMON
  // =====================================================
  processButtonText = 'Authorize';
  searchInput = '';
  categorySearchInput = '';
  productSearchInput = '';
  subProductCategorySearchInput = '';
  productTypeSearchInput = '';
  productDurationSearchInput = '';
  productDurationHeading = '';
  productDurationSearchText = '';
  subProductCategoryHeading = '';
  subProductCategorySearchText = '';
  productTypeHeading = '';
  productTypeSearchText = '';
  contactSearchInputPlaceholder = 'Search beneficiary';
  electricityMeterSearchInput = '';
  contactSearchInput = '';

  closeErrorPopup(): void {
    this.showErrorPopup = false;
    this.showAuthorizeButton = true;
  }
  return(view: string){
    this.productSummary = '';
    this.serviceFeeSummary = '';
    this.electricityMeterSummary = '';
    this.amountSummary = '';
    this.amount = null;
    this.contactSearchInput = '';
    this.categorySearchInput = '';
    this.productSearchInput = '';
    this.subProductCategorySearchInput = '';
    this.productTypeSearchInput = '';
    this.productDurationSearchInput = '';
    this.amountValidationMessage = '';

    if(view === 'beneficiaries'){
      this.selectedContact = null;
      this.showMainProductCategorySection = false;
      this.showBeneficiarySection = true;

       if(this.saveContact){
          this.showAddNewContact = false;
          this.saveContact = false;
          this.newContactName = '';
          this.newContactNumber = '';
        }
    }
    else if(view === 'mainCategories'){
      this.selectedMainProductCategory = null;

      this.showProductsSection = false;
      this.showSubProductCategorySection = false;
      this.showElectricityMeterSection = false;

      this.showMainProductCategorySection = true;
    }
    else if(view === 'subCategories'){
      this.selectedSubProductCategory = null;

      this.showProductTypeSection = false;

      this.showSubProductCategorySection = true;
    }
    else if(view === 'productTypes'){
      this.selectedProductType = null;

      this.showProductDurationSection = false;

      this.showProductTypeSection = true;
    }
    else if(view === 'fromProducts'){
      this.showProductsSection = false;

      if(this.selectedProductDuration)
      {
        this.selectedProductDuration = null;
        this.showProductDurationSection = true;
      }
      else if(this.selectedSubProductCategory)
        this.return('subCategories');
      else if(this.selectedMainProductCategory)
        this.return('mainCategories');
    }
    else if(view === 'fromTransactionSummary'){
      this.showTransactionSummary = false;

      if(this.selectedMainProductCategory.name === 'Prepaid Electricity'){
        this.showElectricityMeterSection = true;
        if(!this.selectedElectricityMeter){
          if(this.saveElectricityMeter){
            this.saveElectricityMeter = false;
            this.newMeterName = '';
            this.newMeterNumber = '';
            this.showAddNewElectricityMeter = false;
            this.showElectricityMeters = true;
          }
          else{
            //this.showAddNewElectricityMeter = true;
            //this.showElectricityMeters = false;
          }
        }
        return;
      }
      else if(this.selectedProduct){
        this.selectedProduct = null;
        if(this.selectedProductType){
          if(this.selectedProductType.type === 'Airtime'){
            this.selectedProductType = null;
            this.showProductTypeSection = true;
            return;
          }
        }
        else if(this.selectedSubProductCategory){
          if(this.selectedSubProductCategory.name === 'Eezi Airtime'){
            this.selectedSubProductCategory = null;
            this.showSubProductCategorySection = true;
            return;
          }
        }
        this.showProductsSection = true;
      }
      else if(this.selectedProductType){
        this.selectedProductType = null;
        this.showProductTypeSection = true;
      }
    }
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = [
    'Backspace',
    'Delete',
    'Tab',
    'Enter',
    'ArrowLeft',
    'ArrowRight',
    'Home',
    'End'
    ];

    // Allow control keys
    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Block everything except digits
    if (!/^[0-9]$/.test(event.key)) {
      event.preventDefault();
    }
  }
}